import { type IntlShape, type MessageDescriptor } from 'react-intl'
import { type PrimitiveType, type FormatXMLElementFn } from 'intl-messageformat'
import { type EN_US_TRANSLATIONS } from 'intl/translations/en-US'

export type DashMessages = keyof typeof EN_US_TRANSLATIONS

export interface DashMessageDescriptor<MessagesT extends string = DashMessages>
  extends MessageDescriptor {
  id: MessagesT
}

// A more strongly typed version of the basic IntlShape
export interface DashIntlShape<TMessageDescriptor = DashMessageDescriptor> extends IntlShape {
  formatMessage(descriptor: TMessageDescriptor, values?: Record<string, PrimitiveType>): string
  formatMessage(
    descriptor: TMessageDescriptor,
    values?: Record<string, PrimitiveType | React.ReactElement | FormatXMLElementFn>
  ): string | React.ReactNodeArray
  formatHTMLMessage(descriptor: TMessageDescriptor, values?: Record<string, PrimitiveType>): string
}

// We have two types here:
// InjectedDashIntlProps is stricter, and requires that ids are valid translation keys
// InjectedIntlProps is looser, letting us just use strings
// The reason for both is because we have some older files using dynamic strings/variabeles
// Eventually, we should migrate to using DashIntlShape/InjectedDashIntlProps for everything
export type InjectedDashIntlProps = {
  intl: DashIntlShape
}

export type InjectedIntlProps = {
  intl: IntlShape
}

/**
 * This message is reserved for triggering
 * default values when provided, and errors regarding
 * this are not necessary when testing.
 *
 * This is useful for instance for translating stuff that comes
 * out of our databases, for instance, Role names
 */
export const INTL_NON_EXISTENT_MESSAGE = '__NON_EXISTENT_MESSAGE__'
